import React from 'react';
import { FileModel } from 'services/EpdClient';
import { ImagesUpload } from 'components/v2/images-upload';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useComparisonContext } from '../hooks/useComparisonContext';
import { VersionLogImageRecord } from '../../version-log/records/VersionLogImageRecord';
import { getCellPresentation, CellVariant } from '../diffHighlight';
import { BlockCell } from './comparisonCells';

const toImages = (raw: unknown): FileModel[] => (Array.isArray(raw) ? raw : []) as FileModel[];

const ImagesCell: React.FC<{ label?: string; propertyId: string; images: FileModel[]; variant?: CellVariant }> = ({
  label,
  propertyId,
  images,
  variant,
}) => (
  <BlockCell $variant={variant}>
    {images.length > 0 && (
      <>
        {label && <SmartLabel label={label} />}
        <ImagesUpload
          name={propertyId}
          images={images}
          onUpload={() => {}}
          onReorder={() => {}}
          onRemove={() => {}}
          disabled
          preferEnabledAppearanceEvenWhenDisabled
        />
      </>
    )}
  </BlockCell>
);

const ImageRenderer: React.FC<VersionLogImageRecord> = ({ label, propertyId }) => {
  const { left, right, diff, side } = useComparisonContext();
  const leftImages = toImages(left.data?.[propertyId]);
  const rightImages = toImages(right.data?.[propertyId]);

  // Empty in both versions → nothing to show (must match the row count in FieldPanelRenderer).
  if (leftImages.length === 0 && rightImages.length === 0) {
    return null;
  }

  const images = side === 'left' ? leftImages : rightImages;
  // ImagesCell hides its own content when the list is empty, so only the colour is taken from the diff.
  const { variant } = getCellPresentation(diff[propertyId], side);
  return <ImagesCell label={label} propertyId={propertyId} images={images} variant={variant} />;
};

export default ImageRenderer;
